import React, { useState } from "react";

const InfoBanner = () => {
  const [isDismissed, setIsDismissed] = useState(false);

  if (isDismissed) {
    return null;
  }

  return (
    <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 flex gap-3 items-start">
      {/* Info Circle Icon */}
      <svg
        className="w-5 h-5 flex-shrink-0 text-blue-600 mt-0.5"
        fill="currentColor"
        viewBox="0 0 20 20"
      >
        <path
          fillRule="evenodd"
          d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
          clipRule="evenodd"
        />
      </svg>

      {/* Content */}
      <div className="flex-1">
        <h3 className="font-semibold text-blue-900 mb-1">Why do we need this?</h3>
        <p className="text-sm text-blue-800">
          Some data points couldn't be automatically extracted from your documents or were not
          pre-filled by your advisor initially. Completing these fields ensures your record is
          complete and paperwork is accurate.
        </p>
      </div>

      {/* Dismiss Button */}
      <button
        onClick={() => setIsDismissed(true)}
        className="flex-shrink-0 text-blue-600 hover:text-blue-900 transition-colors font-semibold text-lg leading-none"
        aria-label="Dismiss banner"
      >
        ×
      </button>
    </div>
  );
};

export default InfoBanner;
